// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2PSrE","header":"ReportDetails_header__95mQ4","title":"ReportDetails_title__1Gyw3","left":"ReportDetails_left__2zdZi"};